// 生成formData
function makeFormData(obj, formdata) {
  let data = [];
  if (obj instanceof File) {
    data.push({ key: "", value: obj });
  } else if (obj instanceof Array) {
    for (let j = 0, len = obj.length; j < len; j++) {
      let arr = makeFormData(obj[j]);
      for (let k = 0, l = arr.length; k < l; k++) {
        let key = formdata ? j + arr[k].key : "[" + j + "]" + arr[k].key;
        data.push({ key: key, value: arr[k].value });
      }
    }
  } else if (typeof obj === "object") {
    for (let j in obj) {
      let arr = makeFormData(obj[j]);
      for (let k = 0, l = arr.length; k < l; k++) {
        let key = formdata ? j + arr[k].key : "[" + j + "]" + arr[k].key;
        data.push({ key: key, value: arr[k].value });
      }
    }
  } else {
    data.push({ key: "", value: obj });
  }
  if (formdata) {
    // 封装
    for (let i = 0, len = data.length; i < len; i++) {
      formdata.append(data[i].key, data[i].value);
    }
  } else {
    return data;
  }
}
// 改变classify列表字段
function parseJson(arr, oldkey, newkey) {
  arr = arr.slice();
  function toParse(arr) {
    arr.forEach(function(item) {
      item[newkey] = item[oldkey];
      if (oldkey !== "id" && oldkey !== "c_parent" && oldkey !== "pid") {
        delete item[oldkey];
      }
      if (item.children && Array.isArray(item.children)) {
        toParse(item.children);
      }
    });
    return arr;
  }
  return toParse(arr);
}
// 商城分类列表去除已选列表
function changeMallClassify(fromData, toData) {
  for (let i = 0; i < toData.length; i++) {
    for (let j = 0; j < fromData.length; j++) {
      if (fromData[j].id === toData[i].id) {
        if (
          fromData[j].children &&
          fromData[j].children.length !== 0 &&
          toData[i].children &&
          toData[i].children.length !== 0
        ) {
          changeMallClassify(fromData[j].children, toData[i].children);
        } else {
          fromData.splice(j, 1);
        }
      }
    }
  }
}
// 去除空值
function clearNullList(fromData, toData) {
  for (let i = 0; i < toData.length; i++) {
    for (let j = 0; j < fromData.length; j++) {
      if (fromData[j].id === toData[i].id) {
        if (
          fromData[j].children &&
          fromData[j].children.length === 0 &&
          toData[i].children &&
          toData[i].children.length !== 0
        ) {
          fromData.splice(j, 1);
        } else if (!fromData[j].children && !toData[i].children) {
          fromData.splice(j, 1);
        } else {
          clearNullList(fromData[j].children, toData[i].children);
        }
      }
    }
  }
}
function changeDateString(date) {
  let year = date.getFullYear();
  let day = date.getDate();
  let month = date.getMonth() + 1;
  let hour = date.getHours();
  let minute = date.getMinutes();
  let second = date.getSeconds();
  return (
    year +
    "-" +
    getDouble(month) +
    "-" +
    getDouble(day) +
    " " +
    getDouble(hour) +
    ":" +
    getDouble(minute) +
    ":" +
    getDouble(second)
  );
}
function changeDate(date) {
  let year = date.getFullYear();
  let day = date.getDate();
  let month = date.getMonth() + 1;
  return year + "-" + getDouble(month) + "-" + getDouble(day);
}
function getDouble(data) {
  if (parseInt(data) < 10) {
    data = "0" + data.toString();
  }
  return data;
}
function currentTime() {
  let now = new Date();
  let year = now.getFullYear();
  let month = now.getMonth() + 1;
  let day = now.getDate();
  let hh = now.getHours();
  let mm = now.getMinutes();
  let ss = now.getSeconds();
  let clock = year;
  if (month < 10) {
    clock += "0";
  }
  clock += month;
  if (day < 10) {
    clock += "0";
  }
  clock += day;
  if (hh < 10) {
    clock += "0";
  }
  clock += hh;
  if (mm < 10) clock += "0";
  clock += mm;
  if (ss < 10) clock += "0";
  clock += ss;
  return clock;
}
// 深拷贝
function deepCopy(obj) {
  if (typeof obj !== "object") return;
  let newObj = obj instanceof Array ? [] : {};
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      newObj[key] =
        typeof obj[key] === "object" ? deepCopy(obj[key]) : obj[key];
    }
  }
  return newObj;
}
function getOdStatusList() {
  let mo_statusList = [];
  if (localStorage.getItem("is_jgj") === "1") {
    mo_statusList = [
      {
        label: "已备货",
        value: "3"
      },
      {
        label: "已扫描",
        value: "4"
      },
      {
        label: "已出库",
        value: "5"
      },
      {
        label: "已到分仓",
        value: "6"
      },
      {
        label: "已取消",
        value: "-1"
      },
      {
        label: "已拒单",
        value: "-2"
      }
    ];
  } else {
    mo_statusList = [
      {
        label: "待接单",
        value: "1"
      },
      {
        label: "备货中",
        value: "2"
      },
      {
        label: "已备货",
        value: "3"
      },
      {
        label: "已扫描",
        value: "4"
      },
      {
        label: "已出库",
        value: "5"
      },
      {
        label: "部分到分仓",
        value: "6_1"
      },
      {
        label: "已到分仓",
        value: "6"
      },
      {
        label: "已取消",
        value: "-1"
      },
      {
        label: "已拒单",
        value: "-2"
      },
      {
        label: "超时未接单",
        value: "-3"
      },
      {
        label: "超时未备货",
        value: "-4"
      }
    ];
  }
  let odStatusList = {
    mo_statusList,
    statusList: [
      {
        label: "正常",
        value: "1"
      },
      {
        label: "已取消",
        value: "-1"
      },
      {
        label: "已拒单",
        value: "-2"
      },
      {
        label: "超时未接单",
        value: "-3"
      },
      {
        label: "超时未备货",
        value: "-4"
      }
    ],
    // 同步状态
    syncStatuslist: [
      {
        label: "未同步",
        value: "0"
      },
      {
        label: "成功",
        value: "1"
      },
      {
        label: "失败",
        value: "2"
      }
    ],
    // 物流状态
    logStatusList: [
      { label: "准备揽件", value: 1 },
      { label: "已揽件", value: 2 },
      { label: "运输中", value: 3 },
      { label: "已签收", value: 4 },
      { label: "拒收带回", value: 5 }
    ]
  };
  return odStatusList;
}

export function transTrackStatus(state, getKeys) {
  const status = {
    1: "准备揽件",
    2: "已揽件",
    3: "运输中",
    4: "已签收",
    5: "拒收带回"
  };
  if (getKeys) {
    return Object.keys(status);
  } else {
    return status[state];
  }
}
/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}
/**
 * @param {string} soureStr  原始字符串
 * @param {Nnmber} beginStr  开始位
 * @param {Nnmber} endStr 结束位
 */
const desensitization = function(soureStr, beginStr, endStr = 0) {
  let str = soureStr + "";
  let len = str.length;
  if (beginStr + endStr > len) {
    return str;
  } else {
    let end = len - endStr;
    let leftStr = str.substring(0, beginStr);
    let rightStr = str.substring(end);
    let result = "";
    try {
      for (let i = 0; i < len - endStr - beginStr; i++) {
        result = result + "*";
      }
    } catch (error) {}
    result = leftStr + result + rightStr;
    return result;
  }
};

/**
 * @description: 生成12位随机数
 * @param {*}
 * @return {*}
 */
export function createRandom(digit) {
  let num = "";
  for (let i = 0; i < digit; i++) {
    num += Math.floor(Math.random() * 10);
  }
  return parseInt(num);
}

/**
 * 检测日期对象
 * @param val
 * @return {boolean}
 */
export function isDate(val = {}) {
  return toString.call(val) === "[object Date]";
}

/**
 * 检测对象
 * @param val 对象
 * @return {boolean} 检测结果
 */
export function isPlainObject(val) {
  return toString.call(val) === "[object Object]";
}

/**
 * 字符编码
 * @param val
 * @return {string}
 */
export function encode(val = "") {
  return encodeURIComponent(val)
    .replace(/%40/g, "@")
    .replace(/%3A/gi, ":")
    .replace(/%24/g, "$")
    .replace(/%2C/gi, ",")
    .replace(/%20/g, "+")
    .replace(/%5B/gi, "[")
    .replace(/%5D/gi, "]");
}

/**
 * 构建url参数
 * @param params 参数对象
 * @return {string} query string
 */
export function buildURL(params = "") {
  if (!params) {
    return "";
  }

  const parts = [];

  Object.keys(params).forEach(key => {
    const val = params[key];

    if (val === null || typeof val === "undefined") {
      return;
    }

    let values = [];
    if (Array.isArray(val)) {
      values = val;
      key += "[]";
    } else {
      values = [val];
    }

    values.forEach(val => {
      if (isDate(val)) {
        // val = val.getTime();
      } else if (isPlainObject(val)) {
        val = JSON.stringify(val);
      }

      parts.push(`${encode(key)}=${encode(val)}`);
    });
  });

  return parts.join("&");
}

// 银行卡号脱敏
export function cardDesensitization(accountNo) {
  return accountNo
    ? accountNo.substr(0, 4) + "******" + accountNo.substr(accountNo.length - 4)
    : "";
}

export function replaceStr(accountNo, preCon, replaceStr) {
  return accountNo
    ? accountNo.substr(0, preCon) +
        replaceStr +
        accountNo.substr(accountNo.length - 4)
    : "";
}

// 格式化小数
// value 输入值
// count 保留小数位数，默认2位（不会进行四舍五入）
export const formatNumber = (value, count = 2) => {
  const tempValue = `${value}`;

  // 含有小数点时，进入该逻辑。金额保持小数点后两位，首重续重保持小数点后四位
  if (tempValue.includes(".")) {
    const tempValueArr = tempValue.split(".");

    if (tempValueArr[0] === "") {
      tempValueArr[0] = 0;
    }

    if (tempValueArr.length === 2) {
      return tempValueArr[1].length > count
        ? `${tempValueArr[0]}.${tempValueArr[1].substr(0, count)}`
        : `${tempValueArr[0]}.${tempValueArr[1]}`;
    }
    return `${tempValueArr[0]}`;
  }

  return tempValue;
};

// post导出
function postExport(postUrl, fileName, params, methods) {
  return new Promise((resolve, reject) => {
    let xhr = new XMLHttpRequest();
    xhr.open(methods || "POST", postUrl, true); // GET/POST方式均可
    xhr.responseType = "blob"; // 重要
    xhr.setRequestHeader("content-type", "application/json"); // 自定义请求头
    xhr.setRequestHeader("Token", localStorage.getItem("token")); // 自定义请求头
    xhr.setRequestHeader("Authorization", localStorage.getItem("token")); // 自定义请求头

    xhr.onload = function() {
      if (this.status == 200) {
        const res = this.response;
        let data = res;
        let fileReader = new FileReader();
        fileReader.onload = function() {
          try {
            let jsonData = JSON.parse(this.result); // 说明是普通对象数据，后台转换失败
            if (jsonData.code) {
              alert(jsonData.message);
              reject({ result: false, message: jsonData.message });
            }
          } catch (err) {
            // 解析成对象失败，说明是正常的文件流
            // alert("success...");
            downLoadBlobFile(res, fileName);
            resolve({ result: true });
          }
        };
        fileReader.readAsText(data);
      }
    };
    xhr.send(JSON.stringify(params));
  });
}
function downLoadBlobFile(res, fileName) {
  const blob = new Blob([res], {
    type: "application/vnd.ms-excel; charset=UTF-8"
  }); // // 重要 导出成excel格式
  let fileURL = URL.createObjectURL(blob);
  let link = document.createElement("a");
  link.style.display = "none";
  link.href = fileURL;
  link.setAttribute("download", fileName + ".xls"); //下载文件名设置(xls格式兼容office的excel)
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
export {
  makeFormData,
  parseJson,
  changeMallClassify,
  clearNullList,
  changeDateString,
  changeDate,
  getOdStatusList,
  currentTime,
  deepCopy,
  desensitization,
  postExport
};



// WEBPACK FOOTER //
// ./src/utils/utils.js